module.exports = __webpack_public_path__ + "img/36_43.c8d601b3.png";